import { Component, OnInit } from '@angular/core';
import { BillingControlService } from '../service/billing-control.service';
import { BcClientListComponent } from '../../bc-client-list/bc-client-list.component';
import { DialogService } from 'ng2-bootstrap-modal';

@Component({
  selector: 'app-bc-effective-state',
  templateUrl: './bc-effective-state.component.html',
  styleUrls: ['./bc-effective-state.component.scss']
})
export class BcEffectiveStateComponent implements OnInit {

  private BcEffectiveUFData = [];
  private BcEffectiveUFTotal = 0;

  //Chart Configuration and Data
  private hasLegend = false
  private chartType = 'horizontalBar'
  private chartData = [
    {
      data: []
    }
  ];
  private chartLabels = [];
  private showChart = false;
  private isLoaded = false;
  private showAll = false;

  constructor(private billingControlService: BillingControlService, private dialogService: DialogService) {
  }

  ngOnInit() {
  }

  onOpenAccordion() {
    if (this.isLoaded == false) {
      this.getBCEffectiveUF();
    }
  }

  getBCEffectiveUF() {
    this.billingControlService.getBCEffectiveUF(this.showAll).subscribe(result => {
      if (result.Success) {
        this.BcEffectiveUFData = result.Result || [];
        this.BcEffectiveUFTotal = result.Total;
        this.isLoaded = true;
        this.defineChartByStateData();
      } else {
        console.log("Erro ao carregar dados de Cobrança Geral");
      }
    }, error => {
      console.log(error);
    });
  }

  defineChartByStateData() {
    if (this.BcEffectiveUFData.length > 1) {
      this.BcEffectiveUFData.forEach((row, index) => {
        row.Nome ? this.addChartData(row.Nome, row.Percentual) : this.addChartData('Sem estado', row.Percentual);
        if (index == this.BcEffectiveUFData.length - 1) {
          this.showChart = true;
        }
      });
    }
  }

  addChartData(label, data) {
    const tempChartData = this.chartData[0].data;
    tempChartData.push(data);
    this.chartData[0].data = tempChartData;
    this.chartLabels.push(label);
  }

  openModal(tipo, chave, dias) {
    const objToList = {
      Tipo: tipo,
      Chave: chave == '' ? undefined : chave,
      Dias: dias,
      Diretoria: this.billingControlService.selectedDirectorship
    };
    this.dialogService.addDialog(BcClientListComponent, { obj: objToList }, { backdropColor: 'rgba(0, 0, 0, 0.5)' });
  }

  onShowAll() {
    this.showAll = true;
    this.getBCEffectiveUF();
  }

  onShowLess() {
    this.showAll = false;
    this.getBCEffectiveUF();
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/billing-control/bc-effective-state/bc-effective-state.component.ts